module.exports = __webpack_public_path__ + "img/yellow.7f78ba5d.svg";